import styled, { css } from "styled-components";

import { colorsPalettes, setElevation, setFontVariant } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

const LABEL_TOOLTIP_MAX_WIDTH = 600;

type LabelFragmentProps = { highlighted?: boolean; grayed?: boolean; ellipsis?: boolean };

/**
 * `Tooltip` has no `maxWidth` or `variation` prop — both are styling now. The `&&` is required to
 * outrank the component's own `&&`-scoped default width.
 */
export const StyledColumnOptionLabelTooltip = styled(Tooltip)`
    && {
        max-width: ${LABEL_TOOLTIP_MAX_WIDTH}px;
        background-color: ${colorsPalettes.carbon[0]};
        color: ${colorsPalettes.carbon[500]};
        border-radius: 6px;
        ${setElevation("Z3")}
    }
`;

export const ColumnOptionLabelFragment = styled.span<LabelFragmentProps>`
    height: 100%;
    line-height: 24px;

    ${(p) =>
        p.highlighted &&
        css`
            background-color: ${colorsPalettes.blue[100]};
        `}

    ${(p) =>
        p.grayed &&
        css`
            color: ${colorsPalettes.carbon[100]};
        `}

    ${(p) =>
        p.ellipsis &&
        css`
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        `}
`;

export const StyledColumnOptionLabel = styled.div<{ hideOverflow?: boolean }>`
    height: 24px;
    white-space: pre;
    display: inline-flex;
    align-items: center;

    ${setFontVariant("subtitle1", colorsPalettes.bluegrey[600])};

    ${(p) =>
        p.hideOverflow &&
        css`
            overflow: hidden;
        `}
`;
